import { firestore } from '../database';

export default {
  fetchIg: id => dispatch => {
    dispatch({
      type: 'FETCH_IG_INITIATED',
      id,
    });

    firestore
      .collection('cache')
      .doc('vendors')
      .collection('instagram')
      .doc(id)
      .get()
      .then(snap => {
        dispatch({
          type: 'FETCH_IG_COMPLETED',
          payload: snap.exists ? snap.data() : null,
          id,
        });
      });
  },
};
